/*global navigator sessionStorage*/
import * as querystring from 'qs';
import { observable, action } from 'mobx';

class DeviceDetection {
  @observable platform = '';
  @observable isIOS = false;
  @observable isAndroid = false;
  @observable isMobile = false;
  @observable adjustUrl = '';

  constructor(ctx) {
    Object.defineProperty(this, 'ctx', {
      value: ctx,
      enumerable: false,
    });
  }

  @action init(value, isConfigValue = true) {
    this.setAdjustUrl(value, isConfigValue);
    this.detectPlatform();
  }

  @action
  setAdjustUrl(value, isConfigValue) {
    const {
      config,
      i18n,
      umDeviceIdentifier,
      utmCookie,
    } = this.ctx;

    let downloadAppsLink = '';

    if (isConfigValue) {
      downloadAppsLink = config.getValue(value, i18n.umRegion);
    } else {
      downloadAppsLink = value;
    }

    let queryObject = {
      umDeviceIdentifier,
    };
    if (utmCookie) {
      queryObject = Object.assign(utmCookie, queryObject);
    }

    let urlSeparator = '?';

    if (downloadAppsLink) {
      urlSeparator = downloadAppsLink.includes('?') ? '&' : '?';
    }

    this.adjustUrl = `${downloadAppsLink}${urlSeparator}label=${encodeURIComponent(querystring.stringify(queryObject))}`;
  }

  @action
  detectPlatform() {
    const userAgent = navigator.userAgent.toLowerCase();
    if (/iphone|ipad|ipod/.test(userAgent)) {
      this.platform = 'iOS';
      this.isIOS = true;
      this.isMobile = true;
    } else if (/android/.test(userAgent)) {
      this.platform = 'Android';
      this.isAndroid = true;
      this.isMobile = true;
    } else {
      this.platform = 'Unknown';
      this.isIOS = false;
      this.isAndroid = false;
      this.isMobile = false;
    }
  }

  dispose() {
    while (this.listeners && this.listeners.length) {
      this.listeners.pop()();
    }
  }
}

export default DeviceDetection;



// WEBPACK FOOTER //
// ./spa/state/deviceDetection.jsx